import { applyTheme } from "./theme";
import { DEFAULT_THEME } from "./themes/registry";

const cookie = document.cookie.match(/(?:^|;\s*)familysite_theme=([^;]+)/)?.[1];
const isLogin = window.location.pathname.replace(/\/+$/, "") === "/login";
applyTheme(isLogin ? DEFAULT_THEME : cookie);
